import { ReceiptTemplateMarkupSlimModel } from 'models'
import {
    getAllReceiptMarkupAction,
    getDefaultReceiptTemplateAction,
} from 'store/actions/receiptTemplate.action'
import { IAction } from 'types/storeTypes'
import { HttpRequestError } from 'httpRequest/HttpRequest'
import { ReceiptTemplateType } from 'constant/receiptTemplateType'

export interface IDefaultReceiptTemplate {
    sale?: ReceiptTemplateMarkupSlimModel
    tableServiceSale?: ReceiptTemplateMarkupSlimModel
    kitchen?: ReceiptTemplateMarkupSlimModel
    billPreview?: ReceiptTemplateMarkupSlimModel
    tableServiceBillPreview?: ReceiptTemplateMarkupSlimModel
    refund?: ReceiptTemplateMarkupSlimModel
}

export interface IReceiptTemplateState {
    defaultReceiptTemplate?: IDefaultReceiptTemplate
    data: ReceiptTemplateMarkupSlimModel[]
    loading: boolean
    error?: HttpRequestError
}

const groupReceiptTemplate = (
    templates: ReceiptTemplateMarkupSlimModel[] | undefined,
): IDefaultReceiptTemplate => {
    const result = {
        sale: templates?.find(
            (i) =>
                i.receiptTemplateType?.receiptTemplateTypeID ===
                ReceiptTemplateType.Sales,
        ),
        tableServiceSale: templates?.find(
            (i) =>
                i.receiptTemplateType?.receiptTemplateTypeID ===
                ReceiptTemplateType.TableServiceSales,
        ),
        kitchen: templates?.find(
            (i) =>
                i.receiptTemplateType?.receiptTemplateTypeID ===
                ReceiptTemplateType.Kitchen,
        ),
        billPreview: templates?.find(
            (i) =>
                i.receiptTemplateType?.receiptTemplateTypeID ===
                ReceiptTemplateType.BillPreview,
        ),
        tableServiceBillPreview: templates?.find(
            (i) =>
                i.receiptTemplateType?.receiptTemplateTypeID ===
                ReceiptTemplateType.TableServiceBillPreview,
        ),
        refund: templates?.find(
            (i) =>
                i.receiptTemplateType?.receiptTemplateTypeID ===
                ReceiptTemplateType.Refund,
        ),
    }
    return { ...result }
}

const initialState: IReceiptTemplateState = {
    loading: false,
    data: [],
}
const receiptTemplate = (
    state: IReceiptTemplateState = initialState,
    action: IAction,
): IReceiptTemplateState => {
    const { payload, type } = action

    switch (type) {
        case getDefaultReceiptTemplateAction.onPending:
        case getAllReceiptMarkupAction.onPending:
            return {
                ...state,
                loading: true,
                error: undefined,
            }
        case getDefaultReceiptTemplateAction.onSuccess: {
            const data = payload as ReceiptTemplateMarkupSlimModel[]

            return {
                ...state,
                loading: false,
                defaultReceiptTemplate: groupReceiptTemplate(data),
            }
        }
        case getAllReceiptMarkupAction.onSuccess:
            return {
                ...state,
                loading: false,
                data: payload,
            }
        case getDefaultReceiptTemplateAction.onFailed:
        case getAllReceiptMarkupAction.onFailed:
            return {
                ...state,
                loading: false,
                error: payload,
            }

        default:
            return state
    }
}

export default receiptTemplate
